import React, { FC } from 'react';

const HelpScoutBeacon: FC = () => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html:
          '<helpghost-widget org-id="2a9bc869-bc01-4491-918f-23c310dcfea4" org-name="Zest MSP" inline-mode="false" primary-color=#ad5cab primary-text=#ffffff background-color=#ffffff background-text=#333333 user-message-color=#d6d6d6 user-message-text-color=#000000 helpghost-message-color=#464a7d helpghost-message-text-color=#ffffff/>',
      }}
    />
  );
};

export default HelpScoutBeacon;
